import { produce } from 'immer'

// Action Types
export const SET_TOOLS = 'tools/setTools'
export const SET_TOOLS_LOADING = 'tools/setLoading'
export const SET_TOOLS_FILTER = 'tools/setFilter'
export const SET_TOOLS_AGENT_OPTIONS = 'tools/setAgentOptions'
export const SET_TOOLS_PLAYBOOK_OPTIONS = 'tools/setPlaybookOptions'
export const SET_EDITING_TOOL = 'tools/setEditingTool'
export const SET_TOOL_FORM_ORGANIZATION = 'tools/setToolFormOrganization'
export const SET_TOOL_FIELD_TYPES = 'tools/setToolFieldTypes'

// Action Creators
export const setTools = (payload) => ({ type: SET_TOOLS, payload })
export const setToolsLoading = (payload) => ({ type: SET_TOOLS_LOADING, payload })
export const setToolsFilter = (section, payload) => ({ type: SET_TOOLS_FILTER, section, payload })
export const setAgentOptions = (payload) => ({ type: SET_TOOLS_AGENT_OPTIONS, payload })
export const setPlaybookOptions = (payload) => ({ type: SET_TOOLS_PLAYBOOK_OPTIONS, payload })
export const setEditingTool = (payload) => ({ type: SET_EDITING_TOOL, payload })
export const setToolFormOrganization = (payload) => ({ type: SET_TOOL_FORM_ORGANIZATION, payload })
export const setToolFieldTypes = (payload) => ({ type: SET_TOOL_FIELD_TYPES, payload })

// State
export const initialState = {
  tools: [],
  loading: {
    fetchTools: false,
    fetchTool: false,
    createTool: false,
    updateTool: false,
    deleteTool: false,
    duplicateTool: null,
    fetchFieldTypes: false,
  },
  editingTool: null,
  formOrganization: null,
  agentOptions: [],
  playbookOptions: [],
  // The type registry from GET /tools/field_types: form field types and card entity types,
  // plus entity-tools' limits
  fieldTypes: [],
  fieldTypeLimits: null,
  filters: {
    organization_id: '',
  },
}

// Reducer
export default function toolsReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_TOOLS:
        newState.tools = payload
        break
      case SET_TOOLS_LOADING:
        newState.loading = { ...newState.loading, ...payload }
        break
      case SET_TOOLS_FILTER:
        newState.filters[action.section] = payload
        break
      case SET_TOOLS_AGENT_OPTIONS:
        newState.agentOptions = payload
        break
      case SET_TOOLS_PLAYBOOK_OPTIONS:
        newState.playbookOptions = payload
        break
      case SET_EDITING_TOOL:
        newState.editingTool = payload
        break
      case SET_TOOL_FORM_ORGANIZATION:
        newState.formOrganization = payload
        break
      case SET_TOOL_FIELD_TYPES:
        newState.fieldTypes = payload.types
        newState.fieldTypeLimits = payload.limits
        break
      default:
        break
    }
  })
}
